import type {PortfolioDashboard} from '../../types/kaldflyte'
import {MetricTile} from '../common/MetricTile'

export function FleetStatusBar({dashboard}: {dashboard: PortfolioDashboard}) {
  const sites = dashboard.sites
  const totalCapacity = dashboard.portfolios.reduce(
    (total, portfolio) => total + portfolio.total_available_kW,
    0,
  )
  const weightedConfidence = totalCapacity
    ? dashboard.portfolios.reduce(
        (total, portfolio) =>
          total +
          portfolio.grid_capacity.confidence_pct *
            portfolio.grid_capacity.available_capacity_kW,
        0,
      ) / totalCapacity
    : 0
  const activeEvents = sites.filter((site) => site.status.active_event).length
  const simulationSites = sites.filter(
    (site) => site.metadata.simulation_mode || site.dashboard?.simulation_mode,
  ).length
  const unknownCapacitySites = dashboard.portfolios.reduce(
    (total, portfolio) =>
      total + portfolio.grid_capacity.excluded_site_ids_unknown_capacity.length,
    0,
  )
  return (
    <section className="metric-grid">
      <MetricTile
        label="Fleet bid-eligible capacity"
        value={`${totalCapacity.toFixed(0)} kW`}
        detail={
          unknownCapacitySites
            ? `${unknownCapacitySites} site${unknownCapacitySites === 1 ? '' : 's'} excluded: prediction unknown`
            : 'All site predictions valid'
        }
      />
      <MetricTile
        label="Fleet confidence"
        value={`${weightedConfidence.toFixed(0)}%`}
        accent={weightedConfidence >= 65 ? 'green' : 'amber'}
      />
      <MetricTile
        label="Active events"
        value={activeEvents}
        accent={activeEvents ? 'red' : 'default'}
      />
      <MetricTile label="Sites online" value={sites.length} />
      <MetricTile
        label="Simulation sites"
        value={simulationSites}
        accent={simulationSites ? 'amber' : 'default'}
      />
    </section>
  )
}
